export default __webpack_public_path__ + "c88219091a22e1e3044e61b7d63df088.png";